// One plan row per date. The API can carry two rows on a date: a session the
// rider skipped next to the one that took its place, or a session next to the
// unplanned-ride row holding the day's other rides (a commute). Every surface
// shows one, so they all have to agree on which: a live session beats an
// unplanned ride, which beats a rest day and a skipped row, and between two
// of a kind the newest (last in the API order) wins. Before this the calendar
// and the week strip took the last row while the day sheet took the first, so
// clicking a day opened a different session than the one shown.
const rank = (d) => (d.status === 'skipped' ? 0 : d.rest ? 1 : d.source === 'import' ? 2 : 3)

export function daysByDate(weeks) {
  const map = {}
  ;(weeks || []).forEach((w) =>
    (w.days || []).forEach((d) => {
      const held = map[d.date]
      if (!held || rank(d) >= rank(held)) map[d.date] = d
    })
  )
  return map
}

// The day's other rows holding rides: what was ridden besides the row shown.
export function otherRidesOn(weeks, day) {
  const rows = []
  ;(weeks || []).forEach((w) => (w.days || []).forEach((d) => d.date === day.date && d.id !== day.id && d.source === 'import' && rows.push(d)))
  return rows.flatMap((d) => d.rides || [])
}
